var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',{staticClass:"mb-2 process-history",attrs:{"resizable":"","data":_vm.serverConfigs,"columns":_vm.serverConfigColumns}})
}
var staticRenderFns = []

export { render, staticRenderFns }